import { QueryClient, QueryClientProvider } from "react-query";
import { useQuery } from "react-query";
import React, { memo, useEffect, useRef, useState } from "react";
import { fetchGetNewCarSalesRankData } from "@Services/api";
import SalesCarItem from "../SalesCarItem";
import { IKindsPcHotSell } from "@Types/api";
import { useSetState } from "ahooks";

const queryClient = new QueryClient();

const SalesRank: React.FC = () => {
  const [data, setdData] = useState<IKindsPcHotSell>({ car: [], suv: [] });
  const [yearKey, setdYearKey] = useState<number | null>(null);
  const [params, setParams] = useSetState({
    active: "suv",
    carFour: true,
    carEight: true,
    suvFour: true,
    suvEight: true,
  });

  const { carFour, carEight, suvFour, suvEight, active } = params;

  const year = useRef(0);
  const month = useRef(0);

  const { refetch } = useQuery(
    "fetchGetNewCarSalesRankData",
    async () => {
      const res = await fetchGetNewCarSalesRankData({ y: year.current, m: month.current, limit: 8 });
      if (res?.status === 12000) {
        let carFour = res.data.car.slice(0, 4).some((item) => !!item.discountTitle);
        let carEight = res.data.car.slice(5, 8).some((item) => !!item.discountTitle);
        let suvFour = res.data.suv.slice(0, 4).some((item) => !!item.discountTitle);
        let suvEight = res.data.suv.slice(5, 8).some((item) => !!item.discountTitle);

        setParams({ carFour, carEight, suvFour, suvEight });
        setdData(res.data);
      }
    },
    { enabled: false },
  );

  const handleClickMonth = (res) => {
    month.current = res;
    refetch();
  };

  const handleClickYear = (res, index) => {
    year.current = res;
    setdYearKey(res);
    month.current = window.YEAR_MONTH && window.YEAR_MONTH[index].month[0];
    refetch();
  };

  useEffect(() => {
    if (!window.YEAR_MONTH) return;
    setdYearKey(window.YEAR_MONTH[0].year);
    year.current = window.YEAR_MONTH[0].year;
    month.current = window.YEAR_MONTH[0].month[0];
    refetch();
  }, []);

  return (
    <section className={`w-full relative mb-40`}>
      {data.car.length !== 0 && data.suv.length !== 0 && (
        <>
          <div className={"font-bold text-24 text-[#333] mb-20 flex justify-start relative"}>
            銷售排行
            <div className={"flex items-center cursor-pointer font-normal"}>
              {Array.isArray(window.YEAR_MONTH) &&
                window.YEAR_MONTH.map((item, index) => (
                  <React.Fragment key={item.year}>
                    <p className={"text-14 text-[#333] ml-24"} onClick={() => handleClickYear(item.year, index)}>
                      {item.year}年
                    </p>
                    {yearKey == item.year && (
                      <div className={"ml-20 flex justify-start"}>
                        {Array.isArray(item.month) &&
                          item.month.map((res) => (
                            <p
                              className={`text-14 py-2 px-8 ${month.current === res ? "bg-[#3264FF] text-white rounded-4" : "text-[#333]"}`}
                              key={res}
                              onClick={() => handleClickMonth(res)}
                              style={{ marginRight: res == 1 ? "0" : "10px" }}
                            >
                              {res}月
                            </p>
                          ))}
                      </div>
                    )}
                  </React.Fragment>
                ))}
            </div>
            <a href='/sales/top' target='_blank' className={"absolute right-0 text-14 text-[#333] cursor-pointer"}>
              更多
            </a>
          </div>

          <div className='flex gap-24 mb-30 text-16 text-black'>
            <div
              className={`${active === "suv" ? "font-medium" : ""} relative cursor-pointer`}
              onClick={() => {
                setParams({ active: "suv" });
              }}
            >
              SUV排行
              {active === "suv" && <div className='bg-[#3264FF] w-20 h-4 rounded-full -bottom-10 left-20 absolute ' />}
            </div>
            <div
              className={`${active === "car" ? "font-medium" : ""} relative cursor-pointer`}
              onClick={() => {
                setParams({ active: "car" });
              }}
            >
              轎車排行
              {active === "car" && <div className='bg-[#3264FF] w-20 h-4 rounded-full -bottom-10 left-20 absolute ' />}
            </div>
          </div>
          <div id="tracking-ModelsHotSalesKind" className={"mt-20 grid grid-cols-4 gap-24"}>
            {data?.car.length > 0 &&
              active === "car" &&
              data?.car.map((item: any, index: number) => (
                <SalesCarItem item={item} key={item.id} visible={index > 3 ? carEight : carFour} />
              ))}
            {data?.suv.length > 0 &&
              active === "suv" &&
              data?.suv.map((item: any, index: number) => (
                <SalesCarItem item={item} key={item.id} visible={index > 3 ? suvEight : suvFour} />
              ))}
          </div>
        </>
      )}
    </section>
  );
};

const Content = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <SalesRank />
    </QueryClientProvider>
  );
};
export default memo(Content);
